import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import Reveal from "./Reveal";
import { SITE } from "../config/site";

const FAQS = [
  {
    q: "How much does a cleaning cost?",
    a: "Every space is different, so we base your free quote on size, frequency, condition and the type of service — and for many standard recurring cleans we can offer a simple flat rate too. Quotes are always free and no-obligation.",
  },
  {
    q: "Are you insured and bonded?",
    a: "Yes. Rock Coast is fully insured and bonded, and we're locally owned right here in the St. John's area.",
  },
  {
    q: "Which areas do you serve?",
    a: "We serve St. John's, Mount Pearl, Paradise, Conception Bay South, Torbay, Portugal Cove–St. Philip's, Logy Bay–Middle Cove–Outer Cove, Bay Bulls / Witless Bay, Pouch Cove — and the whole Avalon. Don't see your community? Just ask.",
  },
  {
    q: "What's the difference between standard and deep cleaning?",
    a: "Standard covers the regular upkeep of kitchens, bathrooms and living areas. Deep cleaning adds detailed scrubbing of grout, cabinets, appliance interiors, baseboards, ceiling fans, light fixtures and trim — ideal as a first-time or seasonal reset.",
  },
  {
    q: "Do you offer recurring service?",
    a: "Yes — standard and commercial cleaning can be scheduled weekly, biweekly or monthly (daily for offices). Recurring visits cost less per visit than one-time cleans. Flexible scheduling available — tell us what works for you.",
  },
  {
    q: "How fast will I hear back after requesting a quote?",
    a: `Within 24 hours. ${SITE.replyPromise} — by email or phone, whichever you prefer.`,
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-7xl px-6 pb-24 lg:px-12 lg:pb-36">
      <div className="grid gap-12 lg:grid-cols-[1fr_1.6fr] lg:gap-24">
        <Reveal>
          <p className="eyebrow">Questions</p>
          <h2 className="mt-4 font-serif text-4xl tracking-tight text-ink sm:text-5xl">
            The things people <span className="italic text-ocean">usually ask</span>
          </h2>
          <p className="mt-6 max-w-sm text-base leading-relaxed text-slateblue">
            Something else on your mind? Ask it in the quote form below — there's a box
            for anything we should know.
          </p>
        </Reveal>

        <Reveal i={1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-ink/10">
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-6 text-left font-serif text-lg tracking-tight text-ink hover:text-ocean hover:no-underline md:text-xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${i}`}
                  className="pb-6 text-base leading-relaxed text-slateblue"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
